import { useQuery } from "@tanstack/react-query";
import { getDealByDealId } from "@/api";
import { EsoDeal } from "@/types";

export const useDealInfo = (dealId?: string) => {
  const query = useQuery<EsoDeal>({
    queryKey: ["dealInfo", dealId],
    queryFn: () => getDealByDealId(dealId!),
    staleTime: 1000 * 60 * 5,
    enabled: !!dealId,
  });

  return {
    ...query,
    data: query.data || null,
  }
};
